"use strict";

import * as bindings from "./bindings";
import * as handlers from "./handlers";
export const init = function init() {
  bindings.bindActions();
};
